import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Directive({
  selector: '[appFullHeightElement]'
})
export class FullHeightElementDirective {
  @Input('offset') offset: string = "0";
  @Output() onWindowResize = new EventEmitter();
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.setElementHeight();
  }

  private setElementHeight() {
    this.onWindowResize.emit({});
    const docHeight = window.innerHeight;
    const boundingRet = this.el.nativeElement.getBoundingClientRect();
    this.el.nativeElement.style.height = `${docHeight - (boundingRet.top + parseInt(this.offset, 10))}px`;
  }

  constructor(private el: ElementRef) {
    setTimeout(() => {
      this.setElementHeight();
    }, 100);
  }
}
